export const SITE_URL = 'https://botanisquare.com'
export const SITE_NAME = 'Botani Square Mall'
export const SITE_ALT_NAME = 'Mal Botani Square'
export const SITE_LOCALE = 'en_US'
export const SITE_LOCALE_ALT = 'id_ID'
export const SITE_LANG = 'en'
export const SITE_DEFAULT_OG = `${SITE_URL}/og-image.jpg`
export const SITE_LOGO = `${SITE_URL}/logo512.png`
export const SITE_DESCRIPTION =
	"Botani Square is Bogor's premier shopping, dining, and lifestyle destination. Explore 200+ stores, exclusive promotions, and family-friendly events at Mal Botani Square."

export const buildCanonical = (path: string): string => {
	if (!path) return `${SITE_URL}/`
	if (path.startsWith('http')) return path
	return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
}

export const stripHtml = (input?: string | null): string => {
	if (!input) return ''
	return input
		.replace(/<[^>]+>/g, ' ')
		.replace(/&nbsp;/g, ' ')
		.replace(/\s+/g, ' ')
		.trim()
}

export const truncate = (input: string, max = 160): string => {
	if (!input) return ''
	if (input.length <= max) return input
	return input.slice(0, max - 1).trimEnd() + '…'
}
